
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class LastNews extends Vue {
  @Prop(Object) lastNews!: any;
}
